export default {

    /**
     * Logs the user in with the auth module and then adds them to our store.
     */
    async login({ dispatch, getters, rootGetters }, data) {
        await this.$auth.loginWith('local', {
            data: {
                ...data,
                basket_id: rootGetters['basket/id'],
            },
        });

        await dispatch('setUser', this.$auth.user);

        if (getters.pendingFavourite) {
            await dispatch('addFavourite', getters.pendingFavourite);
        }
    },

    /**
     * Sets the user in the store and maps their address to our data structure.
     */
    setUser({ commit }, user) {
        commit('setUser', {
            ...user,
            addresses: user.addresses.map((address) => ({
                id: address.id || '',
                name: address.name || '',
                firstLine: address.line_1 || '',
                secondLine: address.line_2 || '',
                thirdLine: address.line_3 || '',
                company: address.company || '',
                city: address.city || '',
                county: address.region || '',
                country: {
                    id: address.country.id,
                    name: address.country.name,
                },
                postcode: address.post_code || '',
                isActive: address.is_active || '',
            })),
        });
    },

    /**
     * Logs the user out of the auth module, resets the basket, checkout and user store modules.
     */
    async logout({ commit, dispatch }) {
        await this.$auth.logout();
        await dispatch('basket/reset', null, { root: true });
        await dispatch('checkout/reset', null, { root: true });
        await commit('reset');
    },

    setFirstName({ commit }, firstName) {
        commit('setFirstName', firstName);
    },

    setLastName({ commit }, lastName) {
        commit('setLastName', lastName);
    },

    setEmail({ commit }, email) {
        commit('setEmail', email);
    },

    setPhone({ commit }, phone) {
        commit('setPhone', phone);
    },

    setGiftMessage({ commit }, giftMessage) {
        commit('setGiftMessage', giftMessage);
    },

    setAddresses({ commit }, addresses) {
        commit('setAddresses', addresses);
    },

    async fetchUser({ dispatch }) {
        await this.$auth.fetchUser();

        dispatch('setUser', this.$auth.user);
    },

    async addFavourite({ dispatch }, productId) {
        await this.$axios.$post('/customer/favourites', {
            product_id: productId,
        });

        await dispatch('fetchUser');
    },

    async removeFavourite({ dispatch }, productId) {
        await this.$axios.$delete('/customer/favourites', {
            data: {
                product_id: productId,
            },
        });

        await dispatch('fetchUser');
    },

    async toggleFavourite({ dispatch, getters }, productId) {
        if (getters.hasFavourite(productId)) {
            await dispatch('removeFavourite', productId);
            return;
        }

        await dispatch('addFavourite', productId);
    },

    setPendingFavourite({ commit }, productId) {
        commit('setPendingFavourite', productId);
    },

};
